export const IMPORT_CUSTOMERS = 'IMPORT_CUSTOMERS';
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const ADD_CUSTOMER_PHOTO = 'ADD_CUSTOMER_PHOTO';
export const IMPORT_SINGLE_CUSTOMER = 'IMPORT_SINGLE_CUSTOMER';
export const IMPORT_CUSTOMER_APPOINTMENTS = 'IMPORT_CUSTOMER_APPOINTMENTS';
export const DELETE_CUSTOMER = 'DELETE_CUSTOMER';
export const IMPORT_LETTERS = 'IMPORT_LETTERS';
export const SELECT_LETTER = 'SELECT_LETTER';
export const IMPORT_REWARD_COUNTER = 'IMPORT_REWARD_COUNTER';
export const GET_CUSTOMER_APPOINTMENT = 'GET_CUSTOMER_APPOINTMENT';
export const CLEAR_CUSTOMER_APPOINTMENTS = 'CLEAR_CUSTOMER_APPOINTMENTS';

export const LOAD_CUSTOMER_PER_PAGE = 50;
export const ALPHABET = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
  'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
  'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X',
  'Y', 'Z',
];
export const ITEM_TYPE = {
  appointment: 'appointment',
  sale: 'sale',
};
